'use client';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { isObservabilityLogsEnabled } from './config';
import type { ObservabilityContext } from './observability.types';

/**
 * Publica os atributos de correlação no RUM e no SDK de Logs.
 *
 * Nos dois porque o SDK de Logs só herda o contexto de RUM em sessão amostrada;
 * fora dela o log sairia sem nenhuma chave de negócio.
 *
 * `setGlobalContextProperty` (aditivo) e nunca `setGlobalContext` (substitui o
 * objeto inteiro, apagando o que já foi publicado).
 */
export function setObservabilityContext(patch: ObservabilityContext): void {
  if (typeof window === 'undefined') return;

  try {
    const logsEnabled = isObservabilityLogsEnabled();

    Object.entries(patch).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      datadogRum.setGlobalContextProperty(key, value);
      if (logsEnabled) {
        datadogLogs.setGlobalContextProperty(key, value);
      }
    });
  } catch {
    // Observabilidade não derruba checkout.
  }
}

/** Recebe o `session_id` do BFF — é a única chave que cruza com o backend. */
export function identifyCheckoutSession(checkoutSessionId?: string): void {
  if (typeof window === 'undefined' || !checkoutSessionId) return;

  try {
    datadogRum.setUser({ id: checkoutSessionId });
    setObservabilityContext({ checkout_session_id: checkoutSessionId });
  } catch {
    // Observabilidade não derruba checkout.
  }
}
